export default __webpack_public_path__ + "static/media/INTJ-3.6fdfc5a8.png";